import { render, staticRenderFns } from "./Otros.vue?vue&type=template&id=787fdf4f&scoped=true"
import script from "./Otros.vue?vue&type=script&lang=ts"
export * from "./Otros.vue?vue&type=script&lang=ts"
import style0 from "./Otros.vue?vue&type=style&index=0&id=787fdf4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787fdf4f",
  null
  
)

export default component.exports